(function ($) {

  $('.closable-ajax-message').click(function () {
    $(this).closest('.c-basket-box').remove();
    $.ajax({
      url: '/message-close.html',
      type: 'GET',
      dataType: 'json',
      data: {message_id: $(this).attr('data-message-id')},
      beforeSend: function (xhr) {
      },
      success: function (data) {
        console.log(data)

      },
      error: function () {

      }
    });
  });


  $(document).on('submit', 'form.hlidaci-pes-form', function (e) { // selector as a parameter
    var form = $(this);
    var url = form.attr('action');
    var action = form.find('input[name="action"]') ;
    var actionStr = action.val() ;
    console.log(e);
    e.preventDefault();
    $.ajax({
      type: 'POST',
      url: url,
      data: form.serialize(),
      dataType:'json',
      success: function(data)
      {
        console.log(data);
        if(data!==null){
        if(data.state='OK'){
          if(actionStr=='activate'){
            form.find('button').html( ' <svg class="icon-svg" fill="none" height="10" viewBox="0 0 14 10" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m1.25 6.25 3 3 8.5-8.5" stroke="#000"/></svg>'+ form.find('button').attr('data-text-remove'));
            form.find('button').removeClass( 'hlidaci-pes-button-2');
            form.find('button').addClass( 'hlidaci-pes-button-1');
            form.find('input[name="action"]').val('deactivate');
          }else{
            form.find('button').text( form.find('button').attr('data-text-add'));
            form.find('button').removeClass( 'hlidaci-pes-button-1');
            form.find('button').addClass( 'hlidaci-pes-button-2');
            form.find('input[name="action"]').val('activate');
          }
        }else{
          form.find('button').after(data.message);
        }
        }
      }

    });


    return false;

  });

  $(document).on('click', '.f-add-to-cart', function (e) { // selector as a parameter
	e.preventDefault();
    var $element = $(this);
    var $form = $element.closest('form');
    var $article = $element.closest('article');

    if ($article.data('timer-button') === undefined){
		$article.data('timer-button',0);
    }

	if ($article.data("request-counter") === undefined){
		$article.data("request-counter",0);
    }

    var timerButton = parseInt($article.data('timer-button') || 0);

    if (timerButton) {
		window.clearInterval(timerButton);
		$article.data('timer-button',0);
	}

	//$element.removeClass('bought'); // Minimálně, nebo:
	markBuyButtonAsReadyToBuy($article, $element, false);

	var requestCounter = parseInt($article.data("request-counter") || 0);
	requestCounter++;
	$article.data("request-counter", requestCounter);

    $.ajax({
      url: $form.attr('action'),
      type: 'GET',
      dataType: 'html',
      data: $form.serialize() + '&ajax-cart=1',
      beforeSend: function (xhr) {
			if (!$element.find('.add-to-cart-loader').length) {
				$element.find('.ico-bag').hide();
				$element.prepend('<span class="add-to-cart-loader"></span>');
			}
      },
      success: function (data) {

			var requestCounterCurrent = parseInt($article.data("request-counter") || 0);
			requestCounterCurrent--;
			$article.data("request-counter", requestCounterCurrent);

        $('.c-basket__price').replaceWith($(data).find('.c-basket__price'));
        if($('.c-basket__reservation').length>0){
			$('.c-basket__reservation').replaceWith($(data).find('.c-basket__reservation'));
        }else{
			$('.c-basket__price').after($(data).find('.c-basket__reservation'));
        }


        initCountdown();
        if ($(data).find('.good').length >0) {
          $('.main').prepend($(data).find('.good'));
          $([document.documentElement, document.body]).animate({
            scrollTop: 0
          }, 200);
        }




		if (!requestCounterCurrent) {
			markBuyButtonAsBoughtt($article, $element);

			$form.find('input[name="pocet"]').val(1);
			var timerButton = parseInt($article.data('timer-button') || 0);
			timerButton = window.setTimeout(function () {
				markBuyButtonAsReadyToBuy($article, $element, true);
			}, 2000);
			$article.data('timer-button',timerButton);

			$element.find('.add-to-cart-loader').remove();
			$element.find('.ico-bag').show();
		}



        $('.c-basket__price').addClass("cart-animate").delay(700).queue(function (next) {
          $(this).removeClass("cart-animate");
          next();
        });

      },
		error: function () {
			var requestCounterCurrent = parseInt($article.data("request-counter") || 0);
			requestCounterCurrent--;
			$article.data("request-counter", requestCounterCurrent);
		}
    });


    return false;
  });
  $(document).on('keyup', '.c-complaint__item--textarea textarea', function () {
    var textareaText = $(this).val();
    var max = parseInt($(this).attr('data-max-length'));
    if(max >0){
      $(this).parent().find('.char-count').html(max - textareaText.length);


    if((max - textareaText.length) <=0){
      $(this).val(textareaText.substring(0, (max-1)));
    }
    }
  });
})(jQuery);



function markBuyButtonAsBoughtt($article, $element) {
	var requestCounter = parseInt($article.data("request-counter") || 0);
	if (requestCounter) return;	// Tj. Probíhá request, tak nic neměníme

	$element.addClass('bought');
	$element.find('span').html($element.attr('data-added-text'));
}

function markBuyButtonAsReadyToBuy($article, $element, withResetPocet) {
	withResetPocet = !!withResetPocet;

	var requestCounter = parseInt($article.data("request-counter") || 0);
	if (requestCounter) return;	// Tj. Probíhá request, tak nic neměníme

	$element.removeClass('bought');
	$element.find('span').html($element.attr('data-add-text'));
	if (withResetPocet) {
		$element.closest('input[name="pocet"]').val(1);
	}
}


function setMarginAndProductionParamValues(element) {
  $option = $(element).find(":selected");
  $marginId = $option.attr("data-margin-id");
  $productionId = $option.attr("data-production-id");
  $priceWithVat = $option.attr("data-price_with_vat");
  $priceWithoutVat = $option.attr("data-price_without_vat");
  $marginWithoutVat = $option.attr("data-margin_without_vat");
  $marginWithVat = $option.attr("data-margin_with_vat");
  $availableQty = $option.attr("data-available-qty");
  $(element).parents('.c-product').find('.c-product__price-value').html($priceWithoutVat);
  $(element).parents('.c-product').find('.avalibity-stock').html($availableQty);
  $(element).parent().find(".margin-hidden-input").val($marginId);
  $(element).parent().find(".production-hidden-input").val($productionId);

  let submit = $(element).parents(".c-product").find("button.f-add-to-cart");
  submit.find("span").html(submit.attr("data-add-text"));
  submit.prop("disabled", false);
};
